/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/default-props-match-prop-types */
import React, { PropTypes, Component } from 'react'
import classnames from 'classnames'
import constants from 'constants'
import Suggestions from './components/Suggestions'
import Spinner from 'components/Spinner'
import { IconSearch } from 'icons'

import styles from './AutoCompleteInput.scss'

class AutoCompleteInput extends Component {
  static propTypes = {
    delimeters: PropTypes.array,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    floatedLabel: PropTypes.bool,
    focus: PropTypes.bool,
    handleChange: PropTypes.func,
    handleChangeAfterClick: PropTypes.func,
    hasFetching: PropTypes.bool,
    label: PropTypes.string,
    minQueryLength: PropTypes.number,
    name: PropTypes.string,
    note: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    suggestions: PropTypes.array,
    valid: PropTypes.bool,
    value: PropTypes.string,
  }

  static defaultProps = {
    clearable: false,
    delimeters: [13, 9],
    disabled: false,
    error: '',
    fetching: false,
    floatedLabel: true,
    hasFetching: false,
    minQueryLength: 2,
    placeholder: '',
    readOnly: false,
    searchable: false,
    suggestions: [],
    valid: true,
  }

  constructor(props) {
    super(props)
    this.timeout = null
    this.state = {
      suggestions: this.props.suggestions,
      query: '',
      selectedIndex: -1,
      selectionMode: false,
      hasFocus: false,
    }
  }

  componentWillReceiveProps(props) {
    this.setState(() => ({ suggestions: props.suggestions }))
  }

  _filteredSuggestions = (query, suggestions) => {
    return suggestions.filter((item) => {
      // filter remaining suggestions by current query
      if (item.label.toLowerCase() === query.toLowerCase()) { return false }
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0
    })
  }

  _addInputByQuery = (query) => {
    let q = query
    if (this.state.selectionMode) {
      const suggestions = this._filteredSuggestions(query, this.props.suggestions)
      q = suggestions[this.state.selectedIndex]
    } else if (query !== '') {
      if (typeof q !== 'object') { q = { label: q, value: q } }
    }
    if (q !== '') { this._addInput(q) }
  }

  // Handlers
  _handleFocus = () => {
    this.props.onFocus(this.props.name)
    this.setState(() => ({ hasFocus: true }))
  }

  _handleBlur = () => {
    clearTimeout(this.timeout)
    if (this.refs.suggestions && document.activeElement === this.refs.suggestions.refs.menu) {
      this._handleFocus()
    } else {
      this.timeout = setTimeout(() => {
        // this._addInputByQuery(this.state.query)
        this.props.onBlur(this.props.name)

        this.setState(() => ({ hasFocus: false }))
      }, 200)
    }
  }

  _handleChange = (e) => {
    const query = e.target.value
    const suggestions = this._filteredSuggestions(query, this.props.suggestions)
    this.setState(() => ({
      query,
      suggestions,
    }))
    this.props.handleChange(this.props.name, query)
  }

  _handleKeyDown = (e) => {
    const { query, suggestions } = this.state

    // Hide suggestions menu on escape
    if (e.keyCode === constants.KEY_CODES.ESC) {
      e.preventDefault()
      this.setState(() => ({
        selectedIndex: -1,
        selectionMode: false,
        suggestions: [],
      }))
    }

    // When one of the terminating keys is pressed, add current query to the tags.
    // If no text is typed in so far, ignore the action - so we don't end up with a terminating
    // character typed in.
    if (this.props.delimeters.indexOf(e.keyCode) !== -1) {
      if (e.keyCode !== constants.KEY_CODES.TAB) {
        e.preventDefault()
      }
      this._addInputByQuery(query)
    }

    // Up Arrow
    if (e.keyCode === constants.KEY_CODES.UP_ARROW) {
      e.preventDefault()
      const si = this.state.selectedIndex

      // On Last item go to the top
      if (si <= 0) {
        this.setState((prevState, props) => ({
          selectedIndex: props.suggestions.length - 1,
          selectionMode: true,
        }))
      } else {
        this.setState(() => ({
          selectedIndex: si - 1,
          selectionMode: true,
        }))
      }
    }

    // Down Arrow
    if (e.keyCode === constants.KEY_CODES.DOWN_ARROW) {
      e.preventDefault()
      this.setState(prevState => ({
        selectedIndex: (prevState.selectedIndex + 1) % suggestions.length,
        selectionMode: true,
      }))
    }

    // Update Input
    if (
      e.keyCode !== constants.KEY_CODES.DOWN_ARROW
      && e.keyCode !== constants.KEY_CODES.UP_ARROW
      && this.props.delimeters.indexOf(e.keyCode) === -1
      && e.keyCode !== constants.KEY_CODES.TAB
      && e.keyCode === constants.KEY_CODES.ESC
    ) {
      this.props.handleChange(this.props.name, query)
    }
  }

  _handleClick = (tag) => {
    clearTimeout(this.timeout)
    // Reset the state
    this.setState(() => ({
      query: tag.value,
      selectedIndex: -1,
      selectionMode: false,
    }))
    this._addInput(tag, true)
  }

  _addInput = (tag, viaClick = false) => {
    const input = this.refs.input

    // Call method to add
    if (
      this.state.selectionMode
      || viaClick
    ) {
      this.props.handleChangeAfterClick(this.props.name, tag)
    }

    this.setState(() => ({
      query: tag.value,
      selectionMode: false,
      selectedIndex: -1,
    }))

    if (this.state.selectionMode || viaClick) { input.focus() }

    // Focus back on the input box
    clearTimeout(this.timeout)
    this.setState(() => ({ hasFocus: true }))
  }

  _input = () => {
    // get the suggestions for the given query
    const query = this.state.query
    const selectedIndex = this.state.selectedIndex
    const suggestions = this.props.suggestions
    const {
      disabled, placeholder, value, fetched, fetching, minQueryLength,
    } = this.props

    return (
      <div className={styles.input} ref="inputContainer" >
        <input
          aria-label={placeholder}
          autoComplete="off"
          disabled={disabled}
          onBlur={this._handleBlur}
          onChange={this._handleChange}
          onFocus={this._handleFocus}
          onKeyDown={this._handleKeyDown}
          placeholder={placeholder}
          ref="input"
          type="text"
          value={value}
        />
        {fetching &&
          <Spinner className={styles.spinner} size="xSmall" />
        }
        {!fetching &&
          <IconSearch className={styles.searchIcon} />
        }
        <Suggestions
          handleClick={this._handleClick}
          minQueryLength={minQueryLength}
          query={query}
          ref="suggestions"
          selectedIndex={selectedIndex}
          show={this.state.hasFocus && fetched}
          suggestions={(fetching || query.length < minQueryLength) ? [] : this._filteredSuggestions(query, suggestions)}
        />
      </div>
    )
  }

  _asHTML = (content) => {
    return {
      __html: content,
    }
  }

  render() {
    const {
      floatedLabel,
      value,
      focus,
      hasFetching,
      error,
      label,
      note,
      disabled,
      valid,
    } = this.props

    const hasError = (error.length) ? 'hasError' : ''
    const allowLabel = (!floatedLabel) ? styles.disablFloatedLabel : ''
    const displayNote = (!valid) ? styles.isHidden : ''
    const classes = {
      [styles.isFocused]: focus,
      [styles.hasValue]: value.length || this.state.query.length,
      [styles.disabled]: disabled,
      [styles.hasFetching]: hasFetching,
    }

    return (
      <div className={classnames(styles.base, allowLabel, classes)}>
        <div className={classnames(styles.tags, styles[hasError])}>
          <div className={styles.selected}>
            {this._input()}
          </div>
        </div>
        <span className={classnames(styles.bar, styles[hasError])} />
        {
          label &&
          <span className={classnames(styles.label, styles[hasError], allowLabel)}>{label}</span>
        }
        {
          error &&
          <span className={classnames(styles.error)} ><span dangerouslySetInnerHTML={this._asHTML(error)} /></span>
        }
        {
          note &&
          <span className={classnames(styles.note, displayNote)}>{note}</span>
        }
      </div>
    )
  }
}

export default AutoCompleteInput



// WEBPACK FOOTER //
// ./src/components/Form/components/AutoCompleteInput/AutoCompleteInput.js